module.exports = __webpack_public_path__ + "img/my-niubi.4e2016f6.png";